/** Affichage téléphone FR : un espace tous les 2 chiffres (ex. 06 76 64 86 15). */
export function formatPhoneFieldValue(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 10);
  if (!digits) return '';

  const chunks: string[] = [];
  for (let i = 0; i < digits.length; i += 2) {
    chunks.push(digits.slice(i, i + 2));
  }
  return chunks.join(' ');
}

export function phoneDigitsOnly(formatted: string): string {
  return formatted.replace(/\D/g, '');
}
